import { NavigateFunction } from 'react-router-dom';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { administrationChildrenBreadcrumbs } from '@/pages/Administration/config';

export const INSTITUTIONAL_WEB_PAGE_NAME = 'Web institucional';
export const LIVE_TRACKING_PAGE_NAME = 'Seguimiento en vivo';
export const DESTINATION_ICON_PAGE_NAME = 'Icono de destino';
export const DRIVER_ICON_PAGE_NAME = 'Icono de repartidor';

export const institutionalWebPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => administrationChildrenBreadcrumbs(navigate);

export const liveTrackingPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...institutionalWebPageBreadcrumbs(navigate),
  {
    label: INSTITUTIONAL_WEB_PAGE_NAME,
    onClick: () => navigate('/institutional-web'),
  },
];

export const liveTrackingChildrenPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...liveTrackingPageBreadcrumbs(navigate),
  {
    label: LIVE_TRACKING_PAGE_NAME,
    onClick: () => navigate('/institutional-web/live-tracking'),
  },
];
